export default __webpack_public_path__ + "static/media/Band saw LAGUNA.a83f8b70.png";